import { render } from "./IconCalendar.vue?vue&type=template&id=f2e3cb00"
import script from "./IconCalendar.vue?vue&type=script&lang=js"
export * from "./IconCalendar.vue?vue&type=script&lang=js"
script.render = render

export default script